import { useUser } from '@myosh/myosh-login';
import { Navigate, Outlet, useLocation } from 'react-router';
import { ThemeProvider } from '@/context/theme-provider';
import { useUsernameGuard } from '@/hooks/use-username-guard';

export const PrivateRoute = () => {
  const { state } = useUser();
  const { search } = useLocation();

  const isWrongUser = useUsernameGuard();

  if (!state.auth) {
    return <Navigate to={{ pathname: '/login', search }} replace />;
  }

  if (state.loginStatus !== 'done' || isWrongUser) {
    return null;
  }

  return (
    <ThemeProvider>
      <Outlet />
    </ThemeProvider>
  );
};
